import React from "react";
import IconNotificationBell from "../../../assets/images/icons/IconNotificationBell";
import NotificationIcon16pxSvg from "../../../assets/images/icons/NotificationIcon16pxSvg";


const NotificationBell = ({ onClick, notifications}) => {

  const count = notifications.length
  const countUnread = notifications.filter(n => n.unread === true).length;


  return (
    <div 
      onClick={onClick}
      className="relative inline-block cursor-pointer group">
      <div className="relative flex items-center justify-center w-11 h-11 rounded-full border-neutral-700 
                  transition-colors duration-300 group-hover:border-[#3B82F6] group-hover:text-[#3B82F6] text-[#404040]">
        <NotificationIcon16pxSvg />
      </div>
      {countUnread > 0 && (
        <span className="absolute top-0 right-1 w-5 h-5 rounded-full bg-[#D00D00] border border-[#FFFFFF] text-white text-[10px] font-normal leading-none flex items-center justify-center">
          {countUnread > 99 ? "99+" : countUnread}
        </span>
      )}
    </div>

  );
};

export default NotificationBell;
